import { useInfiniteQuery } from "@tanstack/react-query";
import notificationService from "..";
import { PaginationParams } from "../type";

const useGetAllNotification = (params: PaginationParams) =>
  useInfiniteQuery({
    queryKey: ["get-notification", params?.IsOpened],
    queryFn: () => notificationService.getNotifications(params),
    getNextPageParam: (lastPage, allPages) => {
      const morePagesExist = lastPage?.result?.length === params.Count; // Assuming 10 items per page
      if (!morePagesExist) return undefined;
      return allPages.length * (params?.Count || 10); // Next page's skip value
    },
  });

export { useGetAllNotification };
